import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Dialog } from 'primereact/dialog'; 
import { Button } from "primereact/button";
import axios from "../../datasource/axios";
import { PROGRAMPROJECTREQUESTLIST_URL } from "../../constants";
import { hideLoader } from "../../datasource/msal";
import "./CppoCodeList.css";
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { InputIcon } from "primereact/inputicon";
import { IconField } from 'primereact/iconfield';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from "primereact/dropdown";
import { EditProgramProject } from "./EditProgramProject";
import CPPActionModal from "./CppoActionDialog";
import { Tooltip } from 'primereact/tooltip';

interface details {
  createdBy: string;
  client: string;
  program: string;
  project: string;
  status: string;
  active: boolean;
  isNewProgram: boolean;
  managedBy: string;
  supportGroupName:string;
  opsVP:string;
}

export const ProgramProjectList = (props: any) => {
  const [cppCodeList, setCppCodeList] = useState<any[]>([]);
  const [cppCodeListFilterdData, setCppCodeListFilteredData] = useState<any[]>([]);
  const [filteredRows, setFilteredRows] = useState<any[]>([]);
  const [actionMode, setActionMode] = useState('');
  const [actionModalVisible, setActionModalVisible] = useState<boolean>(false);
  const [rowId, setRowId] = useState(0);
  const [isEdit, setIsEdit] = useState(false);
  const [details, setdetails] = useState<details>({ createdBy: "", client: "", program: "", project: "", status: "", active: false, isNewProgram: false, managedBy: "", supportGroupName: "", opsVP: "" });
  const [filters, setFilters] = useState<any>({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    createdBy: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    client: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    program: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    project: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    status: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    active: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const dt = useRef(null);
  const toast = useRef<any>(null);
  const [mode, setMode] = useState('');
  const [selectedstatus, setSelectedStatus] = useState({ name: 'Pending', code: '2' });
  const statuslist = [
    { name: 'All', code: '0' },
    { name: 'Draft', code: '1' },
    { name: 'Pending', code: '2' },
    { name: 'Approved', code: '3' },
    { name: 'Rejected', code: '4' }
  ];

  const getSeverity = (status: string) => {
    switch (status) {
      case 'Approved':
        return 'success';

      case 'Rejected':
        return 'danger';

      default:
        return 'info';
    }
  };

  function Callback(mappings: any) {
   setCppCodeList(mappings);
   // handleStatusFilter({ name: 'All', code: '0' });
    if (selectedstatus.name !== 'All') {
      setCppCodeListFilteredData(mappings.filter((item: any) => item.status === selectedstatus.name));
      setFilteredRows(mappings.filter((item: any) => item.status === selectedstatus.name));
    }
    else {
      setCppCodeListFilteredData(mappings);
      setFilteredRows(mappings);
    }
  }

  useEffect(() => {
    initFilters("");
    fetchDashboard();
  }, []);

  useEffect(() => {
    handleStatusFilter(selectedstatus);
  }, [cppCodeList]);

  const showActionModal = (rowId: number, actionType: string) => {
    setActionModalVisible(true);
    setActionMode(actionType);
    setRowId(rowId);

  }

  const reasonTemplate = (rowData: any) => {
    return (
      <>
      <Tooltip target=".custom-target-icon" />
      <i className="custom-target-icon"
         data-pr-position="right"
         data-pr-at="right+5 top"
         data-pr-my="left center-2"
        data-pr-tooltip={rowData.comment}
        style={{ fontSize: '1.5rem',
        cursor: 'pointer',
        height: '5rem'      
       }}>
      <Tag value={rowData.status} severity={getSeverity(rowData.status)} />
      </i>
      </>
    );
  };

  const getCppRequestListByUserid = () => {

    let BASE_URL =  process.env.REACT_APP_API_URI;
    let url = BASE_URL + PROGRAMPROJECTREQUESTLIST_URL;

    return new Promise((resolve, reject) => {
      try {
        axios.getRequest(url)
          .then((res: any) => {
            hideLoader();
            resolve(res);
          })
          .catch((err: any) => {
            resolve(err);
          });
      } catch (error: any) {
        reject(error);
      }
    });
  };

  const fetchDashboard = async () => {
    const response: any = await getCppRequestListByUserid();
    setCppCodeList(response);
    setCppCodeListFilteredData(response);
    setFilteredRows(response);
  }


  const initFilters = (pendingFilter?: any) => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      createdBy: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      client: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      program: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      project: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      status: {
        operator: FilterOperator.AND,
        constraints: [{ value: pendingFilter, matchMode: FilterMatchMode.IN }],
      },
      active: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    });
    setGlobalFilterValue("");
  };

  const updateFilteredValues = (filteredData: any) => {
    setFilteredRows(filteredData);
  }

  const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const value = e.target.value;
      let _filters = { ...filters };

      _filters["global"]["value"] = value;

      setFilters(_filters);
      setGlobalFilterValue(value);
    } catch (e: any) {
      e.stack
        .split("\n")
        .slice(1)
        .map((r: string) => r.match(/\((?<file>.*):(?<line>\d+):(?<pos>\d+)\)/))
        .forEach((r: { groups: { file: any; line?: any; pos?: any } }) => {
          if (r && r.groups && r.groups.file.substr(0, 8) !== "internal") {
            const { file, line, pos } = r.groups;
            //const f = fs.readFileSync(file, 'utf8').split('\n')
            alert(line + ":" + pos);
            // alert(f[line - 1].trim());
          }
        });
    }
  };

  const EditForm = (val: details, mode : string) => {
    setdetails(val);
    setIsEdit(true);
    setMode(mode);
  }

  const actionBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        {!rowData.active && rowData.status !== "Pending" && rowData.status !== "Rejected" && rowData.showEdit  && <Button icon="pi pi-pencil" rounded outlined className="actionicon" tooltip="Edit" onClick={() => EditForm(rowData, 'edit')} />}
        {(!rowData.active && rowData.status === "Pending" && rowData.showApproveorReject) && <Button icon="pi pi-check" rounded outlined className="actionicon" severity="success" tooltip="Approve" onClick={() => showActionModal(rowData.id, 'Approve')} />}
        {(!rowData.active && rowData.status === "Pending" && rowData.showApproveorReject) && <Button icon="pi pi-times" rounded outlined className="actionicon" severity="danger" tooltip="Reject" onClick={() => showActionModal(rowData.id, 'Reject')} />}
        {<Button icon="pi pi-eye" severity="secondary" rounded outlined className="actionicon" tooltip="View" onClick={() => EditForm(rowData, 'view')} />}
      </React.Fragment>
    );
  };


  const renderHeader = () => {
    const value = filters['global'] ? filters['global'].value : '';

    return (
      <div className="headerstyle">
        <div className="hdrstyleone">
          <IconField iconPosition="left">
            <InputIcon className="pi pi-search" />
            <InputText type="search" value={value || ''} onChange={(e) => onGlobalFilterChange(e)} placeholder="Global Search" />
          </IconField>
        </div>
        <div className="hdrstyletwo">
          Select Status : <Dropdown value={selectedstatus} onChange={(e) => handleStatusFilter(e.value)} options={statuslist} optionLabel="name"
            placeholder="Select Status" className="w-full md:w-14rem" />
        </div>
      </div>
    );
  };

  const handleStatusFilter = (val: any) => {
    setSelectedStatus(val);
    if (val.name !== 'All') {
      setCppCodeListFilteredData(cppCodeList.filter(item => item.status === val.name));
      setFilteredRows(cppCodeList.filter(item => item.status === val.name));
    } else {
      setCppCodeListFilteredData(cppCodeList);
      setFilteredRows(cppCodeList);
    }
  }

  const header = renderHeader();

  function sortcolumn(data: any, field: any, order: any) {
    return data.sort((a: any, b: any) => {
      if (a[field] > b[field]) { return order; }
      if (b[field] > a[field]) { return -(order); }
      return 0;
    })
  }

  const handleDialogClose = (val : boolean) => {
    setIsEdit(val);
  }

  const CPPActions = (val: any) => {
    setActionModalVisible(val);
  }

  return (
    <div className="row m-2 mt-4">
    <div className="col-md-12">
      <h4>Program/Project Requests</h4>
      <Toast ref={toast} />
      <DataTable
        onValueChange={filteredData => updateFilteredValues(filteredData)}
        ref={dt}
        value={cppCodeListFilterdData}
        tableStyle={{ minWidth: '93rem' }}
        header={header}
        filters={filters}
        globalFilterFields={[
          "createdBy",
          "client",
          "program",
          "project",
          "status",
          "active",
        ]}
       // loading={loading}
        emptyMessage="No Program/Project requests found."
        paginator rows={25} rowsPerPageOptions={[5, 10, 25, 50]}
        stripedRows
        showGridlines
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      >
      <Column header="Action" body={actionBodyTemplate} exportable={false} style={{ minWidth: '14rem' }}></Column>
        <Column
          field="createdBy"
          header="Created By"
          style={{ textAlign: "center" }}
          sortable
          filter
          filterPlaceholder="Search by Created By"
        ></Column>
        <Column
          field="client"
          header="Client"
          style={{ textAlign: "center" }}
          className="reqDetails"
          sortable
          filter
          filterPlaceholder="Search by Client"
        ></Column>
        <Column
          field="program"
          header="Program"
          style={{ textAlign: "center" }}
          className="reqDetails"
          sortable
          sortFunction={(e: any) => sortcolumn(e.data, e.field, e.order)}
          filter
          filterPlaceholder="Search by Program"
        ></Column>
        <Column
          field="project"
          header="Project"
          style={{ textAlign: "center" }}
          sortable
          sortFunction={(e: any) => sortcolumn(e.data, e.field, e.order)}
          filter
          filterPlaceholder="Search by Project"
        ></Column>
        <Column
          body={reasonTemplate}
          style={{ textAlign: "center" }}
          field="status"
          header="Status"
          sortable
        >
        </Column>
        <Column
          field="active"
          header="Active"
          style={{ textAlign: "center" }}
          sortable
        ></Column>
        <Column
          field="id"
          hidden
        ></Column>
            <Column
          field="isNewProgram"
          hidden
        ></Column>
           <Column
          field="managedBy"
          hidden
        ></Column>
           <Column
          field="supportGroupName"
          hidden
        ></Column>
           <Column
          field="opsVP"
          hidden
        ></Column>
        <Column
          field="timeZoneId"
          hidden
        ></Column>
        <Column
          field="timeZoneName"
          hidden
        ></Column>
         <Column
          field="userId"
          hidden
        ></Column>
         <Column
          field="managerId"
          hidden
        ></Column>
           <Column
          field="showEdit"
          hidden
        ></Column>
           <Column
          field="showApproveorReject"
          hidden
        ></Column>
      </DataTable>

      <Dialog
        style={{ width: "600px", height: "600px" }}
        visible={isEdit}
        onHide={() => handleDialogClose(false)}
        header={mode === "view" ? <h3>View Program/Project Request</h3> : <h3>Edit Program/Project Request</h3>}
        
      >
      {<EditProgramProject details={details} handleCallback={handleDialogClose} handleDataCallback={Callback} mode={mode}/>}
      </Dialog>
      <CPPActionModal visible={actionModalVisible} mode={actionMode} rowId={rowId} CPPActions={CPPActions} handleCallback={Callback} type={2}></CPPActionModal>
      <div>
      </div>
      </div>
      </div>
  );
};

